import { useAlert } from 'providers/AlertModalProvider';
import postData from 'services/postData';

export default function useHandleUpdate(handleRefresh, handleClose) {
  const { showAlert } = useAlert();

  const handleUpdate = async (
    values,
    endpoints,
    setModalLoading,
    label,
    name
  ) => {
    setModalLoading(true, `Updating ${label}`);
    // _method: 'PUT'
    const request = await postData({ ...values }, endpoints, {
      method: 'POST'
    });
    if (request.status) {
      setModalLoading(false);
      showAlert({
        variant: 'info',
        message: `Approval has been successfully raised to update the ${label} ${name}.`
      });
      handleRefresh();
      handleClose();
    } else {
      setModalLoading(false);
      if (request.message?.includes('Status is Pending')) {
        handleClose();
        showAlert({
          variant: 'warning',
          message: `Failed to update the ${label}; this ${label} approval is pending.`
        });
        handleRefresh();
      } else {
        setModalLoading(false);
        showAlert({
          variant: 'danger',
          message: `Failed to update the ${label} ${name}, ${request.message}.`
        });
      }
    }
  };
  return handleUpdate;
}
